import { useEffect, useRef } from "react";
import { styled } from 'styled-components';
import { StepOperator, StepOperators } from '@/types/assistants';
import {Button} from "@/components/ui/Button.tsx";
import {IoChevronDown} from "react-icons/io5";
import {useState} from "react";


const MenuContainer = styled.div`
  position: absolute;
  top: 120%;
  right: 0;
  background: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  z-index: 1000;
  min-width: 150px;
`;

const MenuItem = styled.div<{ $isSelected?: boolean }>`
  padding: 8px 16px;
  cursor: pointer;
  font-size: 14px;
  color: ${props => props.$isSelected ? '#4D699C' : '#333'};
  background: ${props => props.$isSelected ? 'rgba(77, 105, 156, 0.1)' : 'transparent'};
  
  &:hover {
    background: rgba(77, 105, 156, 0.1);
  }
`;

interface OperatorContextMenuProps {
  currentOperator: StepOperator;
  availablePromptOperators: StepOperator[];
  onSelect: (operator: StepOperator) => void;
  step: number;
  disabled?: boolean
}

export const OperatorContextMenu = ({
  currentOperator,
  availablePromptOperators,
  onSelect,
  step,
  disabled
}: OperatorContextMenuProps) => {
  const [isVisible, setIsVisible] = useState(false);
  const menuRef = useRef<HTMLDivElement | null>(null);

  const operators = StepOperators
      .concat(availablePromptOperators)
      .filter(i => i !== `PROMPT_${step}`)
      .filter(i => i !== 'CODE' || currentOperator === 'CODE')
      .sort((a,b) => a.localeCompare(b));

    const handleSelect = (operator: StepOperator) => {
        setIsVisible(false);
        onSelect(operator)
    }

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
                setIsVisible(false); // Закрываем меню
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

  return (
      <div>
          <Button
              variant="ghost"
              padding="3px 10px"
              style={{fontSize: '14px'}}
              className="operator-button"
              disabled={disabled}
              onClick={() => setIsVisible(true)}
          >
              <IoChevronDown size={14}/>
          </Button>
          {isVisible && (
              <div className="operator-context-menu operator-menu" ref={menuRef}>
                  <MenuContainer
                      className="operator-menu"
                      tabIndex={0}
                  >
                      {operators.map(operator => (
                          <MenuItem
                              key={operator}
                              $isSelected={operator === currentOperator}
                              onClick={() => handleSelect(operator as StepOperator)}
                          >
                              {operator}
                          </MenuItem>
                      ))}
                  </MenuContainer>
              </div>
          )}
      </div>
  );
};
